import { Injectable } from '@angular/core';
import { WorkQueueService } from '@core/services//work-queue//work-queue.service';
import { WorkQueueDetails } from '@core/services/work-queue/work-queue.model';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as lenderReconciliationActions from './lenderreconciliation-queue.actions';

@Injectable()
export class LenderReconciliationQueueEffect {
  constructor(private actions$: Actions, private workQueueService: WorkQueueService) { }

  
  loadlenderreconciliationqueues$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<lenderReconciliationActions.LOADLENDERRECONCILIATIONQUEUE>(
      lenderReconciliationActions.LenderReconciliationQueueActionTypes.LOAD_LENDERRECONCILIATIONQUEUE
    ),
    mergeMap((action: lenderReconciliationActions.LOADLENDERRECONCILIATIONQUEUE) =>
      this.workQueueService.GetWorkQueue(action.queuetype, action.workqueueStatusId, action.accountUpdateOptionId, action.customerFollowUpOptionId, action.investigationOptionId, action.insuranceFollowUpOptionId).pipe(
        map(
          (potentialmovedetails: WorkQueueDetails) =>
            new lenderReconciliationActions.LOADLENDERRECONCILIATIONQUEUESUCCESS(potentialmovedetails)
        ),
        catchError(err => of(new lenderReconciliationActions.LOADLENDERRECONCILIATIONQUEUEFAIL(err)))
      )
    )
  ));
}
